module.exports = __webpack_public_path__ + "static/img/blscH5.3e7afe2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blscH5.png
// module id = Oxe1
// module chunks = 0